import React from 'react'
import {FaPhoneAlt} from 'react-icons/fa'
import {Button} from 'react-bootstrap'

export default function MailForm() {
    return (
        <>
            <div className="CallForm">
                <h3>Call us</h3>
                <p>Give us a missed call and we we contact you back in 24 hours</p>
                <Button className='Button' as="a" href="tel:+916300408104"><span><FaPhoneAlt /></span>&nbsp;&nbsp;&nbsp;Call</Button>
            </div>
        </>
    )
}